import * as d3 from 'd3';
import * as moment from 'moment';

import { AugmentedLog } from '../../../models';

export interface StackedLogs {
    name: string;
    values: {
        x: Date,
        y: number,
        y0: number
    }[];
}

export function stackdata(data: AugmentedLog[]): StackedLogs[] {
    try {
        const extent = d3.extent(data, d => d.moment.toDate());
        const mindate: Date = extent[0];
        const maxdate: Date = extent[1];
        const minMinutes = moment(mindate).startOf('m');
        const maxMinutes = moment(maxdate).startOf('m')
            .add(1, 'm');
        const totalDuration = maxMinutes.diff(minMinutes);
        const dates: moment.Moment[] = [];
        const duration = moment.duration(1, 'm');
        const currentdate = minMinutes.clone();
        while (currentdate < maxMinutes) {
            dates.push(currentdate.clone());
            currentdate.add(duration);
        }
        const paired = d3.pairs(dates);
        const byLevel = d3.nest<AugmentedLog>()
            .key(d => d.level)
            .entries(data);
        const countByMinutes = byLevel.map(d => {
            return {
                name: d.key,
                values: paired.map(date => {
                    return {
                        x: date[0].toDate(),
                        y: d.values.filter(v => (v.moment >= date[0] && v.moment < date[1])).length
                    };
                })
            };
        });
        const stack = d3.layout.stack<any, any>()
            .values(d => d.values);
        const stacked = stack(countByMinutes);
        return stacked;
    } catch (error) {
        console.error(error);
    }
}